(function () {
  'use strict';

  var RESERVATION_KEY = 'cartxReservationExpiry';
  var lastItemCount = null;
  var lastCart = null;
  var applyingItemBadges = false;
  var syncTimer = null;
  var reservationSeconds = 300;

  function strings() {
    return window.cartxStrings || {};
  }

  function formatMoney(cents, withCurrency) {
    try {
      if (window.theme && typeof window.theme.formatMoney === 'function') {
        var format = withCurrency
          ? window.theme.moneyWithCurrencyFormat || window.theme.moneyFormat
          : window.theme.moneyWithoutCurrencyFormat || window.theme.moneyFormat;
        return window.theme.formatMoney(cents, format);
      }
    } catch (e) {}
    return (cents / 100).toFixed(2);
  }

  function parsePercent(title) {
    var match = /(\d+)\s*%/.exec(title || '');
    return match ? parseInt(match[1], 10) : null;
  }

  function getAppliedDiscount(cart) {
    var applications = cart.cart_level_discount_applications || [];

    if (applications.length > 0) {
      var totalAmount = 0;
      applications.forEach(function (app) {
        totalAmount += app.total_allocated_amount;
      });
      return { title: applications[0].title, amount: totalAmount };
    }

    var title = null;
    var amount = 0;

    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (alloc) {
        if (!title) {
          title = alloc.discount_application && alloc.discount_application.title;
        }
        amount += alloc.amount;
      });
    });

    return title ? { title: title, amount: amount } : null;
  }

  function updateHeaderCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      var limit = parseInt(el.getAttribute('data-limit'), 10);
      el.setAttribute('data-cart-count', cart.item_count);
      el.textContent = limit && cart.item_count >= limit ? '9+' : cart.item_count;
    });
  }

  function findTicketForCount(count, scope) {
    var found = null;

    (scope || document).querySelectorAll('.cartx-ticket').forEach(function (ticket) {
      var min = parseInt(ticket.getAttribute('data-min-qty'), 10) || 0;
      if (count >= min) found = ticket;
    });

    return found;
  }

  function ticketPercentValue(ticket) {
    if (!ticket) return null;

    var el = ticket.querySelector('[data-ticket-percent]');
    if (!el) return null;

    var match = /(\d+)/.exec(el.getAttribute('data-default-percent') || el.textContent || '');
    return match ? parseInt(match[1], 10) : null;
  }

  function updateTickets(cart) {
    var wraps = document.querySelectorAll('[data-discount-tickets]');
    if (!wraps.length) return;

    var count = cart.item_count;
    var applied = getAppliedDiscount(cart);
    var appliedPercent = applied ? parsePercent(applied.title) : null;

    wraps.forEach(function (wrap) {
      var tickets = wrap.querySelectorAll('.cartx-ticket');
      var activeTicket = applied ? findTicketForCount(count, wrap) : null;

      tickets.forEach(function (ticket) {
        var isActive = ticket === activeTicket;
        ticket.classList.toggle('is-active', isActive);

        var percentEl = ticket.querySelector('[data-ticket-percent]');
        if (percentEl && isActive && appliedPercent) {
          percentEl.textContent = '-' + appliedPercent + '%';
        } else if (percentEl) {
          percentEl.textContent = percentEl.getAttribute('data-default-percent') || percentEl.textContent;
        }
      });
    });
  }

  function updateDiscountLine(cart) {
    var lines = document.querySelectorAll('[data-discount-summary]');
    if (!lines.length) return;

    var applied = getAppliedDiscount(cart);

    lines.forEach(function (line) {
      if (!applied) {
        line.hidden = true;
        return;
      }

      var percent = parsePercent(applied.title) || ticketPercentValue(findTicketForCount(cart.item_count));
      var percentEl = line.querySelector('[data-discount-percent]');
      var amountEl = line.querySelector('[data-discount-amount]');

      if (percentEl) {
        var suffix = line.getAttribute('data-off-label') || strings().offLabel || '';
        percentEl.textContent = percent ? percent + '%' + (suffix ? ' ' + suffix : '') : suffix;
      }

      if (amountEl) {
        amountEl.textContent = '-' + formatMoney(applied.amount, true);
      }

      line.hidden = false;
    });
  }

  function updateTotal(cart) {
    document.querySelectorAll('.cart__checkout-price[data-cart-total]').forEach(function (el) {
      var freeLabel = el.getAttribute('data-free-label') || strings().freeLabel || '';
      el.setAttribute('data-cart-total', cart.total_price);
      el.textContent = cart.total_price === 0 && freeLabel ? freeLabel : formatMoney(cart.total_price, true);
    });
  }

  function applyItemSavings(cart) {
    applyingItemBadges = true;
    updateItemSavings(cart);
    setTimeout(function () {
      applyingItemBadges = false;
    }, 0);
  }

  function updateItemSavings(cart) {
    var label = strings().savingsLabel;
    if (!label) return;

    (cart.items || []).forEach(function (item) {
      document.querySelectorAll('.cart__item[data-item="' + item.key + '"]').forEach(function (itemEl) {
        var priceEl = itemEl.querySelector('.cart__price');
        if (!priceEl) return;

        var original = typeof item.original_line_price === 'number' ? item.original_line_price : item.price * item.quantity;
        var final = typeof item.final_line_price === 'number' ? item.final_line_price : item.line_price;
        var savings = Math.max(0, original - (typeof final === 'number' ? final : original));
        var rendered = parseInt(itemEl.getAttribute('data-savings'), 10);

        if (!isNaN(rendered)) savings = Math.max(0, rendered);

        var badge = priceEl.querySelector('[data-item-savings]');

        if (savings > 0) {
          var text = '(' + label + ' ' + formatMoney(savings) + ')';

          if (!badge) {
            badge = document.createElement('span');
            badge.setAttribute('data-item-savings', '');
            badge.className = 'cart-upsell__item-savings';
            badge.textContent = text;
            priceEl.appendChild(badge);
          } else if (badge.textContent !== text) {
            badge.textContent = text;
          }
        } else if (badge) {
          badge.remove();
        }
      });
    });
  }

  function getReservationExpiry() {
    var stored;
    try {
      stored = sessionStorage.getItem(RESERVATION_KEY);
    } catch (e) {
      return null;
    }
    if (!stored) return null;
    var expiry = parseInt(stored, 10);
    return isNaN(expiry) ? null : expiry;
  }

  function isReservationActive() {
    var expiry = getReservationExpiry();
    if (!expiry) return false;
    if (expiry <= Date.now()) {
      try {
        sessionStorage.removeItem(RESERVATION_KEY);
      } catch (e) {}
      return false;
    }
    return true;
  }

  function resetReservation() {
    try {
      sessionStorage.setItem(RESERVATION_KEY, String(Date.now() + reservationSeconds * 1000));
    } catch (e) {}
    updateReservedBar(lastCart);
  }

  function formatReservationTime(totalSeconds) {
    var minutes = Math.floor(totalSeconds / 60);
    var seconds = totalSeconds % 60;
    return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
  }

  function updateReservedBar(cart) {
    var bars = document.querySelectorAll('[data-cart-upsell-reserved]');
    if (!bars.length) return;

    var count = cart ? cart.item_count : 0;
    var visible = count > 0 && isReservationActive();

    bars.forEach(function (bar) {
      var minutes = parseInt(bar.getAttribute('data-reservation-minutes'), 10);
      if (minutes > 0) reservationSeconds = minutes * 60;
      bar.style.display = visible ? '' : 'none';
    });
  }

  function reservationTick() {
    updateReservedBar(lastCart);

    document.querySelectorAll('[data-cart-upsell-timer]').forEach(function (timerEl) {
      var expiry = getReservationExpiry();
      var remainingMs = expiry ? expiry - Date.now() : 0;
      timerEl.textContent = formatReservationTime(Math.max(0, Math.floor(remainingMs / 1000)));
    });
  }

  function syncNow() {
    fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        lastCart = cart;

        if (lastItemCount !== null && cart.item_count > lastItemCount) {
          resetReservation();
        }
        lastItemCount = cart.item_count;

        updateHeaderCount(cart);
        updateTickets(cart);
        updateDiscountLine(cart);
        updateTotal(cart);
        applyItemSavings(cart);
        updateReservedBar(cart);
      })
      .catch(function () {});
  }

  function syncAll() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncNow, 80);
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncNow();

    var holder = document.querySelector('[data-items-holder]');
    if (holder && window.MutationObserver) {
      new MutationObserver(function () {
        if (applyingItemBadges || !lastCart) return;
        applyItemSavings(lastCart);
      }).observe(holder, { childList: true, subtree: true });
    }
  });

  ['theme:cart:add', 'theme:cart:change', 'theme:cart:refresh', 'theme:cart:update', 'theme:product:add'].forEach(
    function (eventName) {
      document.addEventListener(eventName, syncAll);
    }
  );

  if (window.fetch) {
    var nativeFetch = window.fetch.bind(window);
    window.fetch = function () {
      var url = arguments[0];
      var urlString = typeof url === 'string' ? url : (url && url.url) || '';
      var isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?/.test(urlString);

      return nativeFetch.apply(window, arguments).then(function (response) {
        if (isCartMutation && response.ok) syncAll();
        return response;
      });
    };
  }

  reservationTick();
  setInterval(reservationTick, 1000);
})();
